var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_c('UsersTable',_vm._b({},'UsersTable',{users: _vm.users, loading: _vm.loading},false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }